import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import logo from './assets/logo.png';
import configData from "./config.json";

function Product() {

  const initialFormData = {
    brand: '',
    name: '',
    part_number: '',
    agbar_code: '',
    price: 0.0,
    fee: 0.0,
    tax: 21.0,
    stock: 0,
    description: '',
    img_url: ''
  }


  const [products, setProducts] = useState([]);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalView, setshowModalView] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [successMessage, setSuccessMessage] = useState('');
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const navigate = useNavigate();


  useEffect(() => {

    fetchProducts();
  }, [navigate]);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleCloseUploadImage = (e) => {
    setShowImageModal(false)
    setImageUrl('')
  }

  const handleUploadImage = async () => {
    if (!selectedFile) {
      setError('Selecciona un archivo');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    const token = document.cookie.split('; ').find(row => row.startsWith('agbar_user_token='))?.split('=')[1];
    if (!token) {
      navigate('/');
      return;
    }

    try {
      const response = await axios.post(`${configData.SERVER_URL}/files/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        }
      });

      // asumimos que el backend devuelve { url: "..." }
      setImageUrl(response.data.url);
      setSuccessMessage('Imagen subida correctamente');
      //setShowImageModal(false);
    } catch (err) {
      setError('Error al subir la imagen');
    }
  };

  const fetchProducts = async () => {
    try {
      const token = document.cookie.split('; ').find(row => row.startsWith('agbar_user_token='))?.split('=')[1];
      if (!token) {
        navigate('/');
        return;
      }
      const response = await axios.get(`${configData.SERVER_URL}/products/all-products`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProducts(response.data);
    } catch (err) {
      setError('Failed to fetch products');
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: ['price', 'fee', 'tax', 'canon'].includes(name) ? parseFloat(value) || 0.0 : name === 'stock' ? parseInt(value) || 0 : value
    });
  };

  const handleAddOrEditProduct = async () => {
    if (!formData.name || !formData.part_number || !formData.agbar_code) {
      setError('Los campos Nombre, Part Number y Código Agbar son obligatorios.');
      return;
    }
    setError('');

    try {
      const token = document.cookie.split('; ').find(row => row.startsWith('agbar_user_token='))?.split('=')[1];
      if (!token) {
        setError('Unauthorized');
        return;
      }

      let response;
      if (editingProduct) {
        response = await axios.put(`${configData.SERVER_URL}/products/${editingProduct.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        response = await axios.post(`${configData.SERVER_URL}/products/`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      if (response.status === 201 || response.status === 200) {
        setSuccessMessage(editingProduct ? 'Producto actualizado correctamente' : 'Producto añadido correctamente');
        setShowModal(false);
        setEditingProduct(null);
        setFormData({ brand: '', name: '', part_number: '', agbar_code: '', price: 0.0, fee: 0.0, tax: 21.0, stock: 0 });
        setProducts(editingProduct ? products.map(p => (p.id === editingProduct.id ? response.data : p)) : [...products, response.data]);
      } else {
        setError('Error al guardar el producto');
      }
    } catch (err) {
      setError('Error al guardar el producto');
    }
  };

  const handleEditProduct = (product) => {
    setFormData(product);
    setEditingProduct(product);
    setShowModal(true);
  };

  const handleViewProduct = (product) => {
    setEditingProduct(product);
    console.log(product)
    setshowModalView(true);
  };

  const handleAddProduct = () => {
    setFormData(initialFormData);
    setEditingProduct(null);
    setShowModal(true);
  };


  const handleDeleteProduct = async (id) => {
    try {
      const token = document.cookie.split('; ').find(row => row.startsWith('agbar_user_token='))?.split('=')[1];
      if (!token) {
        setError('Unauthorized');
        return;
      }

      await axios.delete(`${configData.SERVER_URL}/products/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      fetchProducts()
      setSuccessMessage('Producto eliminado correctamente');
    } catch (err) {
      setError('Error al eliminar el producto');
    }
  };


  const handleUndeleteProduct = async (id) => {
    try {
      const token = document.cookie.split('; ').find(row => row.startsWith('agbar_user_token='))?.split('=')[1];
      if (!token) {
        setError('Unauthorized');
        return;
      }

      await axios.put(`${configData.SERVER_URL}/products/${id}/undelete`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      fetchProducts()

      setSuccessMessage('Producto restaurado correctamente');
    } catch (err) {
      setError('Error al restaurar el producto');
    }
  };






  const downloadExcell = async () => {
    try {
      const token = document.cookie.split('; ').find(row => row.startsWith('agbar_user_token='))?.split('=')[1];
      if (!token) {
        setError('Unauthorized');
        return;
      }
      const response = await axios.get(`${configData.SERVER_URL}/products/all-products`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const ws = XLSX.utils.json_to_sheet(response.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Productos");
      XLSX.writeFile(wb, "productos.xlsx");
    } catch (err) {
      setError('Error al descargar el archivo Excel');
    }
  };



  return (

    <>


      {showImageModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Subir Imagen</h5>
              </div>

              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Seleccionar imagen</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/png, image/jpeg"
                    onChange={handleFileChange}
                  />
                </div>

                {imageUrl && (
                  <div className="alert alert-info mt-3">
                    URL: {imageUrl}
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseUploadImage}
                >
                  Cerrar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleUploadImage}
                >
                  Subir
                </button>
              </div>

            </div>
          </div>
        </div>
      )}



      <header className="navbar navbar-expand-md d-print-none" data-bs-theme="dark">
        <div className="container-xl">

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
            <img src={logo} width={150} />
          </div>
        </div>

      </header>
      <br /><br />
      <div className="container">
        <h1>Todos los productos</h1>
        {error && <div className="alert alert-important alert-danger" role="alert">{error}</div>}
        {successMessage && <div className="alert alert-important alert-success" role="alert">{successMessage}</div>}

        <br /><br />
        <div className="row g-2 align-items-center">
          <div className="col-md-2">
            <button className="btn btn-primary mb-3" onClick={() => handleAddProduct()}><i className="fa fa-plus" aria-hidden="true"></i>&nbsp;Añadir Productos</button>
          </div>
          <div className="col">
            <button className="btn btn-primary mb-3" onClick={() => setShowImageModal(true)}><i className="fa fa-image" aria-hidden="true"></i>&nbsp;Añadir Imagen</button>
          </div>
          <div className="col-auto ms-auto d-print-none">

            <button className="btn btn-secondary mb-3" onClick={() => downloadExcell()}><i className="fas fa-file-excel" aria-hidden="true"></i>&nbsp;Descargar Excell</button>
          </div>
        </div>


        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Marca</th>
              <th>Producto</th>
              <th>PN</th>
              <th>Precio</th>
              <th>Stock</th>
              <th>IVA</th>
              <th>Editar</th>
              <th>Ver</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {products.map(product => (
              <tr key={product.id}>
                <td>{product.id}</td>
                <td>{product.brand}</td>
                <td>{product.name}</td>
                <td>{product.part_number}</td>
                <td>{product.price}€</td>
                <td>{product.stock}</td>
                <td>{product.tax / 100}</td>

                <td>

                  {product.DeletedAt ? (
                    ""
                  ) : (
                    <i className="fa fa-edit" onClick={() => handleEditProduct(product)}></i>
                  )}
                </td>
                <td><i className="fa fa-eye" onClick={() => handleViewProduct(product)}></i></td>
                <td>
                  {product.DeletedAt ? (
                    <i className="fa fa-undo" onClick={() => handleUndeleteProduct(product.id)}></i>
                  ) : (
                    <i className="fa fa-trash" onClick={() => handleDeleteProduct(product.id)}></i>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {showModal && (
          <div className="modal" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{editingProduct ? 'Editar Producto' : 'Añadir Producto'}</h5>
                </div>
                <div className="modal-body">
                  {Object.keys(formData).map((key) => (
                    (!editingProduct || !['id', 'created_at', 'updated_at'].includes(key)) && ( // Ocultar solo al editar
                      <div className="form-group" key={key}>
                        <label className="form-label">{key.replace('_', ' ').toUpperCase()}</label>
                        <input
                          type="text"
                          className="form-control"
                          name={key}
                          value={formData[key]}
                          onChange={handleChange}
                        />
                      </div>
                    )
                  ))}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cerrar</button>
                  <button className="btn btn-primary" onClick={handleAddOrEditProduct}>Guardar</button>
                </div>
              </div>
            </div>
          </div>
        )}

      {showModalView && (
          <div className="modal" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Datos de producto</h5>
                </div>
                <div className="modal-body">

                  <h2>{editingProduct.name}</h2>
                  <p>{editingProduct.description}</p>
                  <img style={{ width: '100%' }} src={editingProduct.img_url} />

                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setshowModalView(false)}>Cerrar</button>
                  
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}




export default Product;